import { isVueRoute, isHybridEnvironment } from "@/common/functions";

export default {
	methods: {
		pushZebraNavigation(to) {
			let toAsHref = to;
			if (typeof toAsHref !== "string") {
				toAsHref = this.$router.resolve(to).href;
			}

			if (
				typeof window === "object" &&
				!isVueRoute(toAsHref) &&
				isHybridEnvironment(window.location.origin)
			) {
				return window.location.assign(toAsHref);
			}

			// TODO remove this when we finish with openweb
			const isOpenWebTrapi =
				isFeatureEnabled("OpenWeb") && this.$route.query?.OpenWeb;

			this.$router.push(
				isOpenWebTrapi
					? {
							path: to,
							query: { OpenWeb: 1 },
					  }
					: to
			);
		},
	},
};
